<template>
  <div class="computing-center-box">
    <div class="grid"></div>
    <div class="computing-center-box-title">
      <AnimeTitle
        :title="$t('computingCenter.title')"
        class="computing-center-box-anime-title"
        svgRefValue="computingCenterAnimeTitle"
        :computingTitle="$t('computingCenter.computingTitle')"
      />
      <div
        class="secondary-title"
        data-animation="fade-scale-up"
        data-once="false"
        style="color: #b6b6bf"
      >
        {{ $t('computingCenter.subTitle') }}
      </div>
    </div>
    <div
      class="computing-center-box_tab"
      data-animation="fade-scale-up"
      data-once="false"
    >
      <div
        v-for="(item, index) in cityList"
        :key="index"
        @mouseenter="handleMouseEnter(item)"
        @mouseleave="handleMouseLeave()"
      >
        {{ item }}
      </div>
    </div>
    <Map
      class="computer-center-map"
      data-animation="fade-scale-up"
      data-once="false"
      ref="mapRef"
      :zoom="1.4"
      :layoutCenter="['50%', '52%']"
      :fontSize="15"
      :isBold="true"
      :isShowLine="false"
    />
  </div>
</template>
<script>
import Map from './Map/index.vue';
export default {
  components: {
    Map,
  },
  computed: {
    cityList() {
      return [
        this.$t('computingCenter.cityList.item1'),
        this.$t('computingCenter.cityList.item2'),
        this.$t('computingCenter.cityList.item3'),
        this.$t('computingCenter.cityList.item4'),
        this.$t('computingCenter.cityList.item5'),
        this.$t('computingCenter.cityList.item6'),
        this.$t('computingCenter.cityList.item7'),
        this.$t('computingCenter.cityList.item8'),
      ];
    },
  },
  methods: {
    handleMouseEnter(item) {
      this.$refs.mapRef.setCityHighlight(item);
    },
    handleMouseLeave() {
      this.$refs.mapRef.setCityHighlight(null);
    },
  },
};
</script>
<style lang="scss" scoped>
.computing-center-box {
  text-align: center;
  width: 100%;
  justify-content: center;
  position: relative;
  background: #231c2b;
  height: 1000px;
  .computing-center-box-title {
    padding-top: 120px;
    // position: absolute;
    width: 100%;
    .computing-center-box-anime-title {
      color: white;
    }
  }
  .grid {
    position: absolute;
    inset: 0;
    z-index: 0;
    opacity: 0.45;
    pointer-events: none;
    background-image: linear-gradient(var(--grid) 1px, transparent 1px),
      linear-gradient(90deg, var(--grid) 1px, transparent 1px);
    background-size: 50px 50px;
  }
  .computer-center-map {
    // position: absolute;
    // padding-top: 150px;
    height: calc(100% - 270px) !important;
  }
  .computing-center-box_tab {
    // position: absolute;
    // top: 280px;
    margin-top: 40px;
    color: white;
    display: flex;
    justify-content: center;
    width: 100%;
    position: relative;
    z-index: 1;
    div {
      padding: 0px 20px;
      height: 38px;
      line-height: 40px;
      border-radius: 24px;
      border: 1px solid #ffffff;
      margin-right: 20px;
      cursor: pointer;
      &:last-child {
        margin-right: 0px;
      }
      &:hover {
        background: #ffffff;
        color: #222226;
      }
    }
  }
}
</style>
